module.exports = __webpack_public_path__ + "static/media/epc.01b29aab.png";